export const user = {
  sessionToken: "anonymous",
  userId: 999,
};
